import { fromLonLat } from "ol/proj";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";

export default function CircleMarker(coordinates, olmap) {
  let [long, lat] = coordinates;
  let layer = new VectorLayer({
    source: new VectorSource({
      features: [
        new Feature({
          geometry: new Point(fromLonLat([long, lat])),
        }),
      ],
    }),
  });
  olmap.addLayer(layer);
}
